import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import EditorialHeader from "../compponents/EditorialHeader";
import EditorialFooter from "../compponents/EditorialFooter";
import serviceImages from "../services/serviceImages";
import "./About.css";
import "./Services.css";

// The existing translations contain paragraph breaks, bold markers and an apostrophe entity.
// Render those as text and React elements without interpreting arbitrary HTML.
function Description({ text }) {
  return text.replace(/&#39;/g, "'").split(/\n\s*\n/).map((paragraph, index) => (
    <p key={index}>{paragraph.split(/(\*\*.*?\*\*)/g).map((part, partIndex) => part.startsWith("**") && part.endsWith("**") ? <strong key={partIndex}>{part.slice(2, -2)}</strong> : part)}</p>
  ));
}

export default function ServicePage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const services = t("serviceList", { returnObjects: true });
  const index = /^(0|[1-9]\d*)$/.test(id || "") ? Number(id) : -1;
  const service = services[index];
  useEffect(() => { window.scrollTo(0, 0); }, [id]);

  return (
    <div className="about-page services-page service-detail-page">
      <a className="about-skip" href="#service-main">{t("about.design.skip")}</a>
      <EditorialHeader />
      <main id="service-main" className="about-wrap">
        <Link className="about-text-link service-back" to="/services"><ArrowLeft size={17} aria-hidden="true" />{t("services.design.back")}</Link>
        {service ? <>
          <section className="service-detail-hero" aria-labelledby="service-title">
            <div className="service-detail-art"><img src={serviceImages[service.image]} alt={service.title} width={600} height={600} fetchpriority="high" /><span className="service-number">{String(index + 1).padStart(2, "0")}</span></div>
            <div className="about-hero-copy"><p className="about-eyebrow">{t(`services.design.${index === 4 ? "potential" : "energy"}`)}</p><h1 id="service-title">{service.title}</h1><p className="services-lead">{service.description}</p><Link className="about-button" to="/contact">{t("buttons.bookNow")}<ArrowUpRight size={20} aria-hidden="true" /></Link></div>
          </section>
          <section className="service-description" aria-labelledby="description-title"><div><p className="about-eyebrow">{t("services.design.inDetail")}</p><h2 id="description-title">{t("services.design.sessionTitle")}</h2></div><div className="service-prose"><Description text={service.fullDescription} /><Link className="about-button" to="/contact">{t("buttons.bookNow")}<ArrowUpRight size={20} aria-hidden="true" /></Link></div></section>
          <nav className="service-other" aria-label={t("services.design.other")}><p className="about-eyebrow">{t("services.design.other")}</p><div>{services.map((item, itemIndex) => itemIndex !== index && <Link key={item.image} to={`/service/${itemIndex}`}><span>{String(itemIndex + 1).padStart(2, "0")}</span><span>{item.title}</span><ArrowUpRight size={18} aria-hidden="true" /></Link>)}</div></nav>
        </> : <section className="service-not-found"><h1>{t("services.design.notFound")}</h1><Link className="about-button" to="/services">{t("services.design.back")}<ArrowUpRight size={20} aria-hidden="true" /></Link></section>}
      </main>
      <EditorialFooter />
    </div>
  );
}
